import { swNumberFilter } from "app/filters/ngFilters";
import type { Translatable } from "app/pages/sales-intelligence/types";
import { DEFAULT_ACTION_PANEL_TRANSLATION_KEY } from "../../constants";
import type { SelectionDropdownItem } from "./types";

export default abstract class SelectionItem implements SelectionDropdownItem {
    constructor(
        public readonly alias: string,
        public readonly id: string,
        public readonly value: number,
        public readonly disabledReason?: Readonly<Translatable>,
        public readonly i18nKeyModifier?: string,
    ) {}

    get translationKeyModifier(): string {
        return this.i18nKeyModifier ?? DEFAULT_ACTION_PANEL_TRANSLATION_KEY;
    }

    formatValue(): string {
        if (typeof this.value === "undefined") {
            return "";
        }

        if (this.value === 0) {
            return String(this.value);
        }

        return swNumberFilter()(this.value);
    }

    abstract getSelectedTranslation(): Readonly<Translatable>;

    abstract getTranslation(): Readonly<Translatable>;
}
